export const USER_INFO_SIG_MSG = 'user requests his personal data.'
